import stateManagement from "../../assets/img/React-State-Management.jpg";
import scrum from "../../assets/img/scrum.jpg";
import reduxToolkit from "../../assets/img/reduxtoolkit.png";
import reactComponents from "../../assets/img/reactComponents.jpg";
import GitHub from "../../assets/img/github.jpg";
import Netlify from "../../assets/img/netlify.jpg";

const BlogCardData = [
  {
    imgsrc: Netlify,
    title: "Netlify",
    text: "Netlify ist eine Plattform, die Entwicklern hilft, Websites und Webanwendungen schnell und einfach zu erstellen, bereitzustellen und zu verwalten. Die Plattform wurde im Jahr 2014 gegründet und hat seitdem stark an Beliebtheit gewonnen, vor allem wegen ihrer Einfachheit und Zuverlässigkeit.",
    source: "https://medium.com/@duranakyol71/netlify-deploying-b7d0b11da48c",
  },
  {
    imgsrc: GitHub,
    title: "Was ist der GitHub?",
    text: "Github ist eine webbasierte Plattform, die es Entwicklern ermöglicht, gemeinsam an Projekten zu arbeiten, Quellcode zu verwalten und zu teilen sowie Fehler zu verfolgen. Es wurde im Jahr 2008 von Tom Preston-Werner und Chris Wanstrath gegründet und im Jahr 2018 von Microsoft übernommen.",
    source: "https://medium.com/@duranakyol71/was-ist-der-github-d1cce65f5132",
  },
  {
    imgsrc: stateManagement,
    title: "React State Managament",
    text: "React state management, React uygulamalarınızda veri yönetimini nasıl yapacağınızı belirler. React’in kendi içinde bir state (durum) mekanizması vardır, ancak bazen uygulamanızdaki verilerin daha iyi yönetilmesi için daha gelişmiş yöntemlere ihtiyaç duyabilirsiniz.",
    source:
      "https://medium.com/@duranakyol71/react-state-management-6711538dc296",
  },
  {
    imgsrc: scrum,
    title: "Scrum nedir?",
    text: "Scrum, Agile yöntemleri arasında yaygın olarak kullanılan bir proje yönetim yöntemidir. İşletmeler ve takımlar tarafından geliştirme süreçlerinde verimlilik ve esneklik amacıyla kullanılır.",
    source: "https://medium.com/@duranakyol71/scrum-nedir-d98ec3640ce8",
  },
  {
    imgsrc: reduxToolkit,
    title: "Redux Toolkit",
    text: "Redux Toolkit, Redux kütüphanesinin kullanımını kolaylaştırmak amacıyla geliştirilen bir araçtır. Bu araç, Redux’un kod yazma sürecini hızlandırmasına ve daha anlaşılır hale getirmesine yardımcı olur. ",
    source: "https://medium.com/@duranakyol71/redux-toolkit-b1712e3ce7b9",
  },
  {
    imgsrc: reactComponents,
    title: "React Components",
    text: "React Component ‘leri kullanıcı arayüzünü şekillendiren, belirli görevleri olan, class veya fonksiyon olarak tanımlanmış, geriye react elementleri döndüren (JSX), opsiyonel olarak parametre (daha sonra bunlara prop diyeceğiz) alan yapı taşlarıdır.",
    source: "https://medium.com/@duranakyol71/react-components-2368284bf753",
  },
];

export default BlogCardData;
